module.exports = __webpack_public_path__ + "img/oliver.ae5620f8.png";